import "@xapp/chat-widget/dist/index.css";

import { ChatWidget } from "@xapp/components";
import React, { FC } from "react";

/**
 * Our help chat
 */
export const HelpChat: FC = () => {
    return (
        <div style={{ height: "100vh" }}>
            <ChatWidget widgetKey={window?.xaStudioConfig?.widgetKey} mode="docked" environment="production" />
        </div>
    );
}